import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { BillAmountMismatchIcon } from './bill-amount-mismatch-icon';

interface PaymentTypeCellProps {
  paymentType: string;
  value: number | string;
  isBillAmountValid?: boolean;
}
export const PaymentTypeCell = ({
  paymentType,
  value,
  isBillAmountValid = true,
}: PaymentTypeCellProps): JSX.Element => (
  <HHStack direction="column">
    <HHTypography hhVariant="caption">{paymentType || '--'}</HHTypography>
    <HHStack direction="row" alignItems="center" spacing={0.5}>
      <HHTypography
        hhVariant="caption"
        color={isBillAmountValid ? 'inherit' : 'error'}
      >
        {typeof value === 'number' ? `$${value ?? '--'}` : value}
      </HHTypography>
      {!isBillAmountValid && <BillAmountMismatchIcon />}
    </HHStack>
  </HHStack>
);
